// extracted by mini-css-extract-plugin
module.exports = {"protoWrapper":"Proto_protoWrapper__Lho0U","protoContainer":"Proto_protoContainer__1PgIZ"};